import { BillingTermMetaResponseDto } from '../../../products/types/response';
import { useOfferActions } from '../../hooks/use-offer-actions';
import { useOfferList } from '../../hooks/use-offer-list';
import { OfferListItemResponseDto } from '../../types/response';
import OfferConfirmDialog from '../offer-confirm-dialog/offer-confirm-dialog';
import OfferListToolbar from '../offer-list-toolbar/offer-list-toolbar';
import SendOfferDialog from '../send-offer-dialog/send-offer-dialog';
import OfferList from './offer-list';

export interface OfferListWrapperProps {
  billingTerms: BillingTermMetaResponseDto[];
  onCreate: () => void;
  onOpen: (offer: OfferListItemResponseDto) => void;
}

const toActionTarget = (offer: OfferListItemResponseDto) => ({ _id: offer._id, mail: offer.customer.mail, isSent: !!offer.sentAt });

const OfferListWrapper = ({ billingTerms, onCreate, onOpen }: OfferListWrapperProps) => {
  const { items, pageCount, isLoading, reload, filter, handleFilterChange, pagination, handlePaginationChange } = useOfferList();
  const { openSend, openOfferFile, openConfirm, sendDialogProps, confirmDialogProps } = useOfferActions(reload);

  return (
    <div className="flex flex-col gap-5">
      <OfferListToolbar filter={filter} onFilterChange={handleFilterChange} onCreate={onCreate} />

      <OfferList
        offers={items}
        billingTerms={billingTerms}
        filter={filter}
        pagination={pagination}
        pageCount={pageCount}
        onPaginationChange={handlePaginationChange}
        isLoading={isLoading}
        onOpen={onOpen}
        onSend={(offer) => openSend(toActionTarget(offer))}
        onViewOfferFile={(offer) => openOfferFile(offer._id)}
        onConfirm={(offer, action) => openConfirm(toActionTarget(offer), action)}
      />

      {sendDialogProps && <SendOfferDialog {...sendDialogProps} />}
      <OfferConfirmDialog {...confirmDialogProps} />
    </div>
  );
};

export default OfferListWrapper;
